module.exports = __webpack_public_path__ + "static/media/close.9892dfca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/topNav/close.svg
// module id = 2353
// module chunks = 0